import React, { useEffect, useMemo, useState } from 'react';

//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';

//Material UI Imports
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';

import { useOrganizationSelect } from '../../context/OrganizationSelectContext';
import { useDispatch, useSelector } from 'react-redux';

import { io } from 'socket.io-client';

function SimpleDialog(props) {
  const { onClose, selectedValue, open, organizations } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  const [form, setForm] = useState({
    date: '',
    entity: '',
    type: '',
    metric: '',
    action: '',
    logType: '',
    quantityDiff: '',
    quantityBefore: '',
    quantityAfter: '',
    client: '',
    details: '',
  });

  const handleChange = (e) => {
    console.log(e.target.name, e.target.value);
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onClose(form);
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth>
      <DialogTitle>Ajouter un historique</DialogTitle>
      <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Date"
          name="date"
          type="datetime-local"
          value={form.date}
          onChange={handleChange}
          fullWidth
          variant='filled'
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <FormControl fullWidth>
          <InputLabel>Entité</InputLabel>
          <Select
            value={form.entity}
            label="Entité"
            name='entity'
            onChange={handleChange}
            variant='filled'

          >
            <MenuItem value={"ESET"}>{"ESET"}</MenuItem>
            <MenuItem value={"O365"}>{"O365"}</MenuItem>
            <MenuItem value={"Centreon"}>{"Centreon"}</MenuItem>
            <MenuItem value={"LSI"}>{"LSI"}</MenuItem>
            <MenuItem value={"Auvik"}>{"Auvik"}</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Type"
          name="type"
          value={form.type}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        <TextField
          label="Metric"
          name="metric"
          value={form.metric}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        <TextField
          label="Action"
          name="action"
          value={form.action}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        <FormControl fullWidth variant="filled">
          <InputLabel>Action</InputLabel>
          <Select
            value={form.client}
            label="Action"
            name='action'
            onChange={handleChange}
          >
            <MenuItem value={"Ajout"}>{"Ajout"}</MenuItem>
            <MenuItem value={"Suppression"}>{"Suppression"}</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Type V2"
          name="logType"
          value={form.logType}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />

        <TextField
          label="Quantité"
          name="quantityDiff"
          type="number"
          value={form.quantityDiff}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        <TextField
          label="Quantité Précédente"
          name="quantityBefore"
          type="number"
          value={form.quantityBefore}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        <TextField
          label="Quantité Actuelle"
          name="quantityAfter"
          type="number"
          value={form.quantityAfter}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        {/* <TextField
          label="Client"
          name="client"
          value={form.client}
          onChange={handleChange}
          fullWidth
        /> */}
        <FormControl fullWidth variant="filled">
          <InputLabel>Client</InputLabel>
          <Select
            value={form.client}
            label="Client"
            name='client'
            onChange={handleChange}
          >
            {organizations.map((org) => (
              <MenuItem value={org._id}>{org.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Détails"
          name="details"
          value={form.details}
          onChange={handleChange}
          fullWidth
          variant='filled'
        />
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={handleClose}>Annuler</Button>
          <Button type="submit" variant="contained">Ajouter</Button>
        </Box>
      </Box>
    </Dialog>
  );
}

const HistoryLog = () => {

  const socket = io(`${process.env.REACT_APP_API_URL}`);





  const [filteredHistory, setFilteredHistory] = useState([]);

  // const [o365Licenses, seto365Licenses] = useState([]);
  const { data: history = [], loading, error } = useSelector((state) => state.history.history);
  console.log(history)
  // const [organizations, setOrganizations] = React.useState([]);
  const { selectedOrganization } = useOrganizationSelect();

  // const fetchOrganizations = async () => {
  //     try {
  //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations/list`);
  //         setOrganizations(response.data.filter((org) => !org.deleted));
  //     } catch (error) {
  //         console.error('Error fetching organizations:', error);
  //     }
  // };

  const dispatch = useDispatch();

  useEffect(() => {

    //  fetchOrganizations();


    // const socketEvents = [
    // "o365:historyLicenseUpdated",
    // "o365:historyUserUpdated",
    // "eset:historyLicenseUpdated",
    // "eset:historyDeviceUpdated",
    // ];

    // socketEvents.forEach(event => {
    // socket.on(event, () => {
    //   console.log(`📡 Événement reçu : ${event}`);
    //   dispatch(fetchHistory());
    // });
    // });



    if (selectedOrganization) {
      setFilteredHistory(history.filter(
        (item) => item.organizationName === selectedOrganization
      ));
    } else {
      setFilteredHistory(history);
    }
  }, [selectedOrganization, history, dispatch]);


  function formatDateTime(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    // Format to French locale datetime string (YYYY-MM-DDTHH:mm for input[type="datetime-local"])
    // Or use toLocaleString for display
    return date.toLocaleString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    // const pad = (n) => n.toString().padStart(2, '0');
    // const day = pad(date.getDate());
    // const month = pad(date.getMonth() + 1);
    // const year = date.getFullYear();
    // const hours = pad(date.getHours());
    // const minutes = pad(date.getMinutes());
    // return `${day}/${month}/${year} ${hours}:${minutes}`;
  }


  const columns = useMemo(
    () => [
      {
        id: 'licenses', //id used to define `group` column
        columns: [
          {
            accessorFn: (row) => new Date(row.timestamp), //accessorFn used to format date
            id: 'date', //id is required when using accessorFn
            header: 'Date',
            size: 100,
            Cell: ({ cell }) => cell.getValue().toLocaleString(),
            filterVariant: 'datetime-range',

          },
          {
            accessorFn: (row) => `${row.entity === "eset" ? "ESET" :
                row.entity === "o365" ? "O365" :
                  row.entity === "centreon" ? "Centreon" :
                    row.entity}`,
            id: 'entity', //id is still required when using accessorFn instead of accessorKey
            header: 'Entité',
            size: 100,
            Cell: ({ row }) => {
              const entity =
                row.original.entity === "eset" ? "ESET" :
                  row.original.entity === "o365" ? "O365" :
                    row.original.entity === "centreon" ? "Centreon" :
                      row.original.entity;

              return (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  {entity}
                </Box>
              );
            },
            filterVariant: 'autocomplete',
          },
          //   {
          //     accessorFn: (row) => `${ 
          //       row.entitySubType.toLowerCase() === "license" ? "License" : 
          //       row.entitySubType.toLowerCase() === "user" ? "Utilisateur" : 
          //       row.entitySubType.toLowerCase() === "device" ? "Appareil" :
          //       row.entitySubType.toLowerCase().includes("storage") ? "Stockage" :
          //       row.entitySubType 
          //     }`,

          //     id: 'entitySubType', //id is still required when using accessorFn instead of accessorKey
          //   header: 'Type',
          //   size: 100,
          //   Cell: ({ row }) => {
          //     const entity =
          //       row.original.entitySubType.toLowerCase() === "license"
          //       ? "License"
          //       : row.original.entitySubType.toLowerCase() === "user" 
          //       ? "Utilisateur"
          //       : row.original.entitySubType.toLowerCase() === "storage"
          //       ? "Stockage"
          //       : row.original.entitySubType.toLowerCase() === "device" 
          //       ? "Appareil"
          //       : row.original.entitySubType;

          //     return (
          //       <Box
          //         sx={{
          //           display: 'flex',
          //           alignItems: 'center',
          //           gap: '1rem',
          //         }}
          //       >
          //         {entity}
          //       </Box>
          //     );
          //   },
          //   filterVariant: 'autocomplete',
          // },

          // {
          //   accessorFn: (row) =>
          //     row.entityType === "used"
          //       ? "Utilisation"
          //       : row.entityType === "total"
          //       ? "Total"
          //       : row.entityType,
          //   id: 'metric', //id is still required when using accessorFn instead of accessorKey
          //   header: 'Metric',
          //   size: 100,
          // },
          // {
          //   accessorKey: 'action', //corrected accessorKey
          //   header: 'Action',
          //   size: 100,
          // },
          {
            accessorKey: 'logType', //corrected accessorKey
            header: 'Type',
            filterVariant: 'autocomplete',
            size: 100,
          },
          {
            accessorKey: 'quantityBefore', //added missing column
            header: 'Avant',
            size: 40,
          },
          {
            accessorKey: 'quantityAfter', //added missing column
            header: 'Après',
            size: 40,
          },
          {
            accessorKey: 'quantityDiff', //added missing column
            header: 'Quantité',
            size: 40,
            Cell: ({ cell }) => (
              <Chip
                label={cell.getValue() > 0 ? `+${cell.getValue()}` : cell.getValue()}
                color={cell.getValue() > 0 ? "success" : "error"}
              />
            ),
          },
          {
            accessorFn: (row) => `${row.organizationDetails?.name}`, //accessorFn used to join multiple data into a single cell
            id: 'organization', //id is still required when using accessorFn instead of accessorKey
            header: 'Client',
            size: 250,
            Cell: ({ renderedCellValue }) => (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                }}
              >
                {renderedCellValue}
              </Box>
            ),
            filterVariant: 'autocomplete',
          },
          {
            accessorFn: (row) => {
              const info = row.details?.additionalInfo;

              if (!info) return '';

              if (row.entity === 'signitic') {
                const base = [
                  info.name || [info.firstname, info.lastname].filter(Boolean).join(' ').trim(),
                  info.email,
                  info.signiticGroup,
                ]
                  .filter(Boolean)
                  .join(' - ');

                return info.changedFieldsSummary
                  ? `${base}${base ? ' | ' : ''}${info.changedFieldsSummary}`
                  : base;
              }

              if (info.userPrincipalName && info.licenseName) {
                return `${info.userPrincipalName} - ${info.licenseName}`;
              }

              if (info.userPrincipalName) {
                return info.userPrincipalName;
              }

              if (info.name) {
                return info.name;
              }

              if (info.licenseName) {
                return info.licenseName;
              }

              return '';
            },
            id: 'details',
            header: 'Détails',
            size: 250,
            Cell: ({ renderedCellValue }) => (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                }}
              >
                {renderedCellValue}
              </Box>
            ),
            filterVariant: 'autocomplete',
          }
        ],
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    localization: MRT_Localization_FR,
    enableGlobalFilter: true,
    enableColumnFilters: true,

    columns,

    data: filteredHistory ? filteredHistory : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableColumnOrdering: true,
    enableGrouping: true,
    enableColumnPinning: true,
    enableFacetedValues: true,
    // enableColumnResizing: true,
    columnResizeMode: 'onEnd',
    // enableRowSelection: true,
    initialState: {
      density: "compact",
      // showColumnFilters: true,
      // showGlobalFilter: true,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
      pagination: {
        pageSize: 50,
      }
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [50, 100, 150],
      shape: 'rounded',
      variant: 'outlined',
    },

  });

  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  };


  return (
    <Box>
      <Box>
        <Typography variant="h6" my={2}>
          Historique
        </Typography>
      </Box>
      <Box display={'flex'} alignContent={'center'} justifyContent={'space-between'} sx={{ mb: 2 }}>

        {/* <Button variant="contained" startIcon={<AddIcon />} size='small' color="primary" onClick={handleClickOpen}>
              Ajouter
            </Button> */}
      </Box>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={600} />
      ) : filteredHistory.length === 0 ? (
        <Box sx={{ textAlign: 'center', p: 2 }}>
          <Typography variant="h6" color="textSecondary">
            Aucune donnée disponible
          </Typography>
        </Box>
      ) : (
        <MaterialReactTable table={table} />
      )}
      {/* <SimpleDialog
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose}
            organizations={organizations}
          /> */}
    </Box>
  )

};


export default HistoryLog